<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <h1>Not Found</h1>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
